import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./etoro.css";
import { useState } from "react";
import { chooseDescriptions, leftContent, rightImages } from "./data";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { useEffect } from "react";

const Etoro = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideWidth, setSlideWidth] = useState(400); // Default width

  const [isPrevDisabled, setIsPrevDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const [isPrevSecDisabled, setIsPrevSecDisabled] = useState(true);
  const [isNextSecDisabled, setIsNextSecDisabled] = useState(false);

  const handleTypes = (index) => {
    setActiveIndex(index);
  };

  const handleSlideChange = (swiper) => {
    setIsPrevDisabled(swiper.isBeginning);
    setIsNextDisabled(swiper.isEnd);
  };

  const handleSlideSecChange = (swiper) => {
    setIsPrevSecDisabled(swiper.isBeginning);
    setIsNextSecDisabled(swiper.isEnd);
  };

  // Update slide width based on breakpoints
  useEffect(() => {
    const updateSlideWidth = () => {
      if (window.innerWidth <= 480) {
        setSlideWidth(360); // Mobile
      } else if (window.innerWidth <= 768) {
        setSlideWidth(300); // Tablet
      } else {
        setSlideWidth(400); // Desktop
      }
    };

    updateSlideWidth(); // Set initial width
    window.addEventListener("resize", updateSlideWidth);
    return () => window.removeEventListener("resize", updateSlideWidth);
  }, []);

  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>eToro Clone | eToro alternative</title>

        <meta name="title" content="eToro Clone | eToro alternative" />
        <meta
          name="description"
          content="Our eToro app like clone provides a robust foundation to launch a competitive trading platform. Whether you aim to target cryptocurrency trading, stock investments, or forex markets, our solutions are highly scalable and customizable."
        />

        <meta property="og:title" content="eToro Clone | eToro alternative" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/etoro-clone"
        />
      </Helmet>

      <main className="etoro-main">
        <div className="etoro-hero-about-wrap">
          {/* hero */}
          <article className="etoro-hero">
            <div className="primary__landing__container">
              <div className="row m-0 etoro-hero-row">
                <div className="col-md-6">
                  <h1 className="etoro-hero-title">
                    eToro clone | eToro alternative
                  </h1>
                  <p className="etoro-hero-content">
                    If you’re looking to develop an eToro alternative, you’ve
                    come to the right place. Our team specializes in creating
                    advanced solutions, tailored to meet your needs and provide
                    your users with a seamless trading experience.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="etoro-btn"
                  >
                    Get Free Consultation{" "}
                    <span className="mx-2 right-arr">
                      <i
                        className="fa-solid fa-arrow-right"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                </div>
                <div className="col-md-6 text-center">
                  <div>
                    <img
                      src={require("../../../image/etoro/hero-right.webp")}
                      alt="eToro Clone"
                    />
                  </div>
                </div>
              </div>
            </div>
          </article>

          {/* about */}
          <article className="primary__landing__container">
            <div className="row m-0 etoro-about-row">
              <div className="col-lg-6 etoro-about-img-col">
                <img
                  src={require("../../../image/etoro/about.webp")}
                  alt="eToro Clone"
                />
              </div>
              <div className="col-lg-6">
                <h5 className="etoro-subtitle">
                  What is{" "}
                  <span className="etoro-about-span">an eToro clone?</span>{" "}
                </h5>
                <p className="etoro-subcontent">
                  An eToro Clone is a ready-made trading platform designed to
                  emulate the features and functionalities of eToro. It supports
                  various trading activities, including forex, stocks,
                  cryptocurrencies, and copy trading.  It is designed to enable
                  users to engage in trading, social investing, and copy
                  trading, offering a user experience similar to eToro while
                  allowing for customization to meet unique business
                  requirements. Whether you’re an entrepreneur or a trading
                  enthusiast aiming to launch a competitive trading platform,
                  Our eToro app like clone is the ideal starting point for the
                  best eToro alternative.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="etoro-btn"
                >
                  Get Quote{" "}
                  <span className="mx-2 right-arr">
                    <i
                      className="fa-solid fa-arrow-right"
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
              </div>
            </div>
          </article>
        </div>

        {/* why choose */}
        <article className="etoro-why-choose">
          <div className="primary__landing__container">
            <h5 className="etoro-subtitle text-center">
              Why Choose <span className="etoro-clr">Our eToro Clone?</span>{" "}
            </h5>
            <p className="etoro-subcontent et-about-mw">
              Our eToro Clone is engineered to deliver an unmatched trading
              experience. Here's why it's the best eToro alternative
            </p>

            <div className="et-choose-mt">
              <div className="row m-0 et-choose-row">
                <div className="col-md-6 et-choose-col-one">
                  <div className="et-choose-left-wrap">
                    {leftContent.map((content, index) => (
                      <div
                        className={`et-choose-left ${
                          activeIndex === index ? "active" : ""
                        }`}
                        key={index}
                        onClick={() => handleTypes(index)}
                      >
                        <div className="et-outer">
                          <span>
                            {activeIndex === index ? (
                              <img src={content.activeImg} alt="eToro Clone" />
                            ) : (
                              <img src={content.img} alt="eToro Clone" />
                            )}
                          </span>

                          <div className="et-width">
                            <div className="d-flex justify-content-between">
                              <h6 className="et-choose-left-title">
                                {content.title}
                              </h6>
                              <span
                                className={
                                  activeIndex === index ? "d-none" : ""
                                }
                              >
                                <i className="fa-solid fa-chevron-right"></i>
                              </span>
                            </div>
                            <p className="et-choose-left-content">
                              {chooseDescriptions[index]}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="et-choose-right">
                    <div className="et-choose-inner">
                      <div
                        className="et-choose-img-track"
                        style={{
                          transform: `translateX(-${
                            activeIndex * slideWidth
                          }px)`,
                          transition: "transform 0.5s ease-in-out",
                        }}
                      >
                        {rightImages.map((src, index) => (
                          <div className="et-choose-img-wrap" key={index}>
                            <img src={src} alt={`Slide ${index}`} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* features */}
        <article className="etoro-features">
          <div className="primary__landing__container">
            <div className="etoro-feature-inner">
              <h5 className="etoro-subtitle ">
                <span className="etoro-about-span">Features of </span>
                Our eToro Clone
              </h5>

              <div className="row g-5 m-0 et-feature-row">
                <div className="col-lg-4 col-sm-6">
                  <div className="et-feature-card">
                    <span>01</span>
                    <div className="et-feature-content">
                      <h6>Copy Trading</h6>
                      <p>
                        The eToro copy trading clone functionality allows novice
                        traders to mimic the strategies of seasoned investors,
                        making trading accessible to everyone.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 et-ft-col-none"></div>
                <div className="col-lg-4 col-sm-6">
                  <div className="et-feature-card">
                    <span>02</span>
                    <div className="et-feature-content">
                      <h6>Multi-Asset Trading</h6>
                      <p>
                        Trade in a wide range of assets, including stocks,
                        forex, cryptocurrencies, and commodities, all under one
                        roof.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="et-feature-card">
                    <span>03</span>
                    <div className="et-feature-content">
                      <h6>Real-Time Analytics</h6>
                      <p>
                        Provide users with real-time market data, charts, and
                        analytics to help them make informed decisions.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 et-ft-col-none"></div>
                <div className="col-lg-4 col-sm-6">
                  <div className="et-feature-card">
                    <span>04</span>
                    <div className="et-feature-content">
                      <h6>Social Trading</h6>
                      <p>
                        Enable users to interact with each other, share
                        strategies, and build a community around trading.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                  <div className="et-feature-card">
                    <span>05</span>
                    <div className="et-feature-content">
                      <h6>Secure Wallet Integration</h6>
                      <p>
                        Ensure seamless and secure transactions with integrated
                        digital wallets.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 et-ft-col-none"></div>
                <div className="col-lg-4 col-sm-6">
                  <div className="et-feature-card">
                    <span>06</span>
                    <div className="et-feature-content">
                      <h6>Customizable Dashboard</h6>
                      <p>
                        Offer users a personalized dashboard to manage their
                        portfolios and track performance.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 et-ft-mobile-show">
                  <img
                    src={require("../../../image/etoro/feature.webp")}
                    alt="eToro Clone"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* Benefits */}
        <article className="etoro-benefit">
          <div className="primary__landing__container">
            <h5 className="etoro-subtitle text-center">
              Benefits of Using Our{" "}
              <span className="etoro-about-span"> eToro Clone</span>
            </h5>

            <div className="et-ben-slider-wrapper">
              <div className="et-ben-slider-parent">
                <div className="et-ben-slider-inner">
                  <button
                    className={`et-ben-prev-arrow ${
                      isPrevDisabled ? "disabled" : ""
                    }`}
                    style={{
                      color: isPrevDisabled ? "#0000215c" : "#000021",
                      cursor: isPrevDisabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                  <button
                    className={`et-ben-next-arrow ${
                      isNextDisabled ? "disabled" : ""
                    }`}
                    style={{
                      color: isNextDisabled ? "#0000215c" : "#000021",
                      cursor: isNextDisabled ? "not-allowed" : "pointer",
                    }}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                  <Swiper
                    spaceBetween={14}
                    slidesPerView={3}
                    modules={[Navigation, A11y, Pagination]}
                    pagination={{
                      clickable: true,
                      // el: ".forex-paginate",
                    }}
                    scrollbar={{ draggable: true }}
                    navigation={{
                      prevEl: ".et-ben-prev-arrow",
                      nextEl: ".et-ben-next-arrow",
                    }}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                      },
                      480: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                      },
                      1025: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                      },
                    }}
                    onSlideChange={handleSlideChange}
                    onReachBeginning={() => setIsPrevDisabled(true)}
                    onReachEnd={() => setIsNextDisabled(true)}
                    onFromEdge={() => {
                      setIsPrevDisabled(false);
                      setIsNextDisabled(false);
                    }}
                  >
                    <SwiperSlide>
                      <div className="et-ben-card">
                        <img
                          src={require("../../../image/etoro/ben-card-img-one.webp")}
                          alt="eToro Clone"
                        />
                        <h6>Fast Deployment</h6>
                        <p>
                          With our eToro app like clone, you can launch your
                          trading platform quickly and efficiently.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="et-ben-card">
                        <img
                          src={require("../../../image/etoro/ben-card-img-two.webp")}
                          alt="eToro Clone"
                        />
                        <h6>Cost-Effective Solution</h6>
                        <p>
                          From scratch trading platform development can be
                          expensive. Our clone offers a budget-friendly
                          alternative without compromising quality.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="et-ben-card">
                        <img
                          src={require("../../../image/etoro/ben-card-img-three.webp")}
                          alt="eToro Clone"
                        />
                        <h6>Proven Success Model</h6>
                        <p>
                          Replicate the success of eToro with a platform that
                          mirrors its core features and functionalities.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="et-ben-card">
                        <img
                          src={require("../../../image/etoro/ben-card-img-four.webp")}
                          alt="eToro Clone"
                        />
                        <h6>Global Reach</h6>
                        <p>
                          Expand your platform with multi-language and
                          multi-currency support globally.
                        </p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="et-ben-card">
                        <img
                          src={require("../../../image/etoro/ben-card-img-five.webp")}
                          alt="eToro Clone"
                        />
                        <h6>Enhanced User Engagement</h6>
                        <p>
                          Features like copy trading and social trading keep
                          users engaged and increase platform retention.
                        </p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* why best */}
        <article className="etoro-best">
          <div className="primary__landing__container">
            <div className="row m-0 et-best-row">
              <div className="col-lg-6">
                <h5 className="etoro-subtitle et-best-mw">
                  Why Is Our eToro Clone the{" "}
                  <span className="etoro-clr">Best eToro AlteGrnative?</span>
                </h5>
                <p className="etoro-subcontent">
                  As the demand for trading platforms grows, there’s a
                  significant opportunity to tap into this market with a unique
                  eToro alternative. Our clone stands out as the best eToro
                  alternative due to its innovative features and cutting-edge
                  technology. Platforms like eToro generate revenue through
                  fees, subscriptions, and premium features. Launching an eToro
                  Clone can help you establish a similar revenue model. Whether
                  you’re targeting experienced traders or beginners, our
                  platform caters to all user segments with ease. With a focus
                  on user satisfaction and business growth, our eToro
                  alternative ensures you stay ahead in the competitive trading
                  market.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="etoro-btn"
                >
                  Get Free Consultation{" "}
                  <span className="mx-2 right-arr">
                    <i
                      className="fa-solid fa-arrow-right"
                      aria-hidden="true"
                    ></i>
                  </span>
                </button>
              </div>
              <div className="col-lg-6 text-center">
                <img
                  src={require("../../../image/etoro/best.webp")}
                  alt="eToro Clone"
                />
              </div>
            </div>
          </div>
        </article>

        {/* copy trading */}
        <article className="et-copy-trade">
          <div className="primary__landing__container">
            <h5 className="etoro-subtitle et-copy-mw">
              {" "}
              <span className="etoro-clr">eToro Copy Trading</span> Clone the
              best eToro alternative
            </h5>

            <div className="et-copy-row-wrap">
              <div className="row mx-0">
                <div className="col-lg-5">
                  <p className="etoro-subcontent">
                    The eToro copy trading clone is one of the most attractive
                    aspects of our solution. This feature enables novice traders
                    to follow and replicate the trading strategies of seasoned
                    professionals. With this functionality, your platform
                    becomes accessible to a broader audience, encouraging
                    participation from both beginners and experts.
                  </p>
                </div>
                <div className="col-lg-1 d-flex align-items-center justify-content-center">
                  <div className="et-copy-line"></div>
                </div>
                <div className="col-lg-6">
                  <h6 className="et-key-ben-title">
                    Key benefits of the eToro copy trading clone
                  </h6>
                  <div className="row mx-0 et-key-ben-row">
                    <div className="col-md-4 et-key-ben-col">
                      <img
                        src={require("../../../image/etoro/copy-img-one.webp")}
                        alt="eToro Clone"
                        className="key-ben-img"
                      />
                      <img
                        src={require("../../../image/etoro/copy-img-one-active.webp")}
                        alt="eToro Clone"
                        className="key-ben-img-active"
                      />
                      <p className="et-key-ben-content">
                        Builds user trust and engagement.
                      </p>
                    </div>
                    <div className="col-md-4 et-key-ben-col">
                      <img
                        src={require("../../../image/etoro/copy-img-two.webp")}
                        alt="eToro Clone"
                        className="key-ben-img"
                      />
                      <img
                        src={require("../../../image/etoro/copy-img-two-active.webp")}
                        alt="eToro Clone"
                        className="key-ben-img-active"
                      />
                      <p className="et-key-ben-content">
                        Encourages social learning and community interaction.
                      </p>
                    </div>
                    <div className="col-md-4 et-key-ben-col">
                      <img
                        src={require("../../../image/etoro/copy-img-three.webp")}
                        alt="eToro Clone"
                        className="key-ben-img"
                      />
                      <img
                        src={require("../../../image/etoro/copy-img-three-active.webp")}
                        alt="eToro Clone"
                        className="key-ben-img-active"
                      />
                      <p className="et-key-ben-content">
                        Simplifies trading for beginners.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* steps to develop */}
        <article className="et-steps">
          <div className="primary__landing__container">
            <h5 className="etoro-subtitle et-sec-mw">
              Steps to <span className="etoro-clr">Develop an eToro </span>
              alternative Clone
            </h5>

            <div className="row mx-0 et-step-row">
              <div className="col-md-4 et-step-card card-one">
                <span>01</span>
                <h6>Market Research</h6>
                <p>Understand your target audience and their preferences.</p>
              </div>
              <div className="col-md-4 et-step-card card-two">
                <span>02</span>
                <h6>Platform Design</h6>
                <p>
                  Create a visually appealing and user-friendly interface for
                  your eToro app like clone.
                </p>
              </div>
              <div className="col-md-4 et-step-card card-three">
                <span>03</span>
                <h6>Feature Development</h6>
                <p>
                  Implement core functionalities such as trading, copy trading,
                  and social interaction.
                </p>
              </div>
              <div className="col-md-4 et-step-card card-two">
                <span>04</span>
                <h6>Security Implementation</h6>
                <p>
                  Advanced security measure integration to protect user funds
                  and data.
                </p>
              </div>
              <div className="col-md-4 et-step-card card-five">
                <span>05</span>
                <h6>Testing</h6>
                <p>
                  Conduct extensive testing to ensure the platform is free of
                  bugs and glitches.
                </p>
              </div>
              <div className="col-md-4 et-step-card card-one">
                <span>06</span>
                <h6>Launch and Marketing</h6>
                <p>
                  Launch your eToro alternative and promote it to attract users.
                  We do exclusive marketing services for your product.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* use cases */}
        <article className="et-use">
          <div className="primary__landing__container">
            <h5 className="etoro-subtitle text-center">
              <span className="etoro-clr">Use Cases of </span>Our eToro Clone
            </h5>

            <div className="row g-3 g-md-5  mx-0 et-use-row">
              {/* one */}
              <div className="col-lg-4 col-md-6 et-use-col-img">
                <img
                  src={require("../../../image/etoro/use-img-one.webp")}
                  alt="eToro Clone"
                />
              </div>
              <div className="col-lg-1 et-use-col-none"></div>
              <div className="col-lg-4 col-md-6 ">
                <div className="et-use-card line-one">
                  <img
                    src={require("../../../image/etoro/use-img-box-one.webp")}
                    alt="eToro Clone"
                    className="use-img-box"
                  />
                  <img
                    src={require("../../../image/etoro/use-img-box-one-active.webp")}
                    alt="eToro alternative"
                    className="use-img-box-active"
                  />
                  <h6>Cryptocurrency Exchange</h6>
                  <p>
                    Provide a safe and easy-to-use platform for cryptocurrency
                    trading.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 et-use-col-none"></div>
              <div className="col-lg-4 et-use-mobile-col">
                <img
                  src={require("../../../image/etoro/use-img-one.webp")}
                  alt="eToro alternative"
                />
              </div>

              {/* two */}
              <div className="col-lg-3 et-use-col-none"></div>
              <div className="col-lg-4 col-md-6">
                <div className="et-use-card line-two">
                  <img
                    src={require("../../../image/etoro/use-img-box-two.webp")}
                    alt="eToro alternative"
                    className="use-img-box"
                  />
                  <img
                    src={require("../../../image/etoro/use-img-box-two-active.webp")}
                    alt="eToro alternative"
                    className="use-img-box-active"
                  />
                  <h6>Forex Trading Platform</h6>
                  <p>
                    Enable users to trade in foreign exchange with real-time
                    market insights.
                  </p>
                </div>
              </div>
              <div className="col-lg-1 et-use-col-none"></div>
              <div className="col-lg-4 col-md-6 et-use-col-img">
                <img
                  src={require("../../../image/etoro/use-img-two.webp")}
                  alt="eToro alternative"
                />
              </div>
              <div className="col-lg-4 et-use-mobile-col">
                <img
                  src={require("../../../image/etoro/use-img-two.webp")}
                  alt="eToro alternative"
                />
              </div>

              {/* three */}
              <div className="col-lg-4 col-md-6 et-use-col-img">
                <img
                  src={require("../../../image/etoro/use-img-three.webp")}
                  alt="eToro alternative"
                />
              </div>
              <div className="col-lg-1 et-use-col-none"></div>
              <div className="col-lg-4 col-md-6">
                <div className="et-use-card line-three">
                  <img
                    src={require("../../../image/etoro/use-img-box-three.webp")}
                    alt="eToro alternative"
                    className="use-img-box"
                  />
                  <img
                    src={require("../../../image/etoro/use-img-box-three-active.webp")}
                    alt="eToro alternative"
                    className="use-img-box-active"
                  />
                  <h6>Social Trading Platform</h6>
                  <p>
                    Build a community where users can interact and share trading
                    strategies.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 et-use-col-none"></div>
              <div className="col-lg-4 et-use-mobile-col">
                <img
                  src={require("../../../image/etoro/use-img-three.webp")}
                  alt="eToro alternative"
                />
              </div>

              {/* four */}
              <div className="col-lg-3 et-use-col-none"></div>
              <div className="col-lg-4 col-md-6">
                <div className="et-use-card">
                  <img
                    src={require("../../../image/etoro/use-img-box-four.webp")}
                    alt="eToro alternative"
                    className="use-img-box"
                  />
                  <img
                    src={require("../../../image/etoro/use-img-box-four-active.webp")}
                    alt="eToro alternative"
                    className="use-img-box-active"
                  />
                  <h6>Multi-Asset Investment</h6>
                  <p>
                    Provide a one-stop solution for trading in various asset
                    classes.
                  </p>
                </div>
              </div>
              <div className="col-lg-1 et-use-col-none"></div>
              <div className="col-lg-4 col-md-6 et-use-col-img">
                <img
                  src={require("../../../image/etoro/use-img-four.webp")}
                  alt="eToro alternative"
                />
              </div>
              <div className="col-lg-4 et-use-mobile-col">
                <img
                  src={require("../../../image/etoro/use-img-four.webp")}
                  alt="eToro alternative"
                />
              </div>
            </div>
          </div>

          <img
            src={require("../../../image/etoro/use-img-left.webp")}
            alt="eToro alternative"
            className="use-left-img-one"
          />
          <img
            src={require("../../../image/etoro/use-img-center.webp")}
            alt="eToro alternative"
            className="use-left-img-two"
          />
          <img
            src={require("../../../image/etoro/use-img-bottom.webp")}
            alt="eToro alternative"
            className="use-left-img-three"
          />
        </article>

        {/* security features */}
        <article className="et-security">
          <div className="primary__landing__container">
            <h5 className="etoro-subtitle et-sec-mw">
              <span className="etoro-clr">Security Features </span>
              in Our eToro Clone
            </h5>

            <div className="et-security-swiper">
              <Swiper
                spaceBetween={14}
                slidesPerView={4}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                  // el: ".forex-paginate",
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".et-sec-prev-arrow",
                  nextEl: ".et-sec-next-arrow",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                }}
                onSlideChange={handleSlideSecChange}
                onReachBeginning={() => setIsPrevSecDisabled(true)}
                onReachEnd={() => setIsNextSecDisabled(true)}
                onFromEdge={() => {
                  setIsPrevSecDisabled(false);
                  setIsNextSecDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="et-security-card">
                    <img
                      src={require("../../../image/etoro/sec-img-one.webp")}
                      alt="eToro alternative"
                    />
                    <h6>Two-Factor Authentication (2FA)</h6>
                    <p>Add an extra layer of security for user accounts.</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="et-security-card">
                    <img
                      src={require("../../../image/etoro/sec-img-two.webp")}
                      alt="eToro alternative"
                    />
                    <h6>End-to-End Encryption</h6>
                    <p>Safeguard sensitive user data.</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="et-security-card">
                    <img
                      src={require("../../../image/etoro/sec-img-three.webp")}
                      alt="eToro alternative"
                    />
                    <h6>Anti-DDoS Protection</h6>
                    <p>Protect the platform from malicious attacks.</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="et-security-card">
                    <img
                      src={require("../../../image/etoro/sec-img-four.webp")}
                      alt="eToro alternative"
                    />
                    <h6>Regulatory Compliance</h6>
                    <p>
                      Ensure adherence to financial regulations and standards.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="et-security-card">
                    <img
                      src={require("../../../image/etoro/sec-img-five.webp")}
                      alt="eToro alternative"
                    />
                    <h6>Real-Time Monitoring</h6>
                    <p>
                      Detect and prevent fraudulent activities in real-time.
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="et-sec-btn-wrapper">
                <button
                  className={`et-sec-prev-arrow ${
                    isPrevSecDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevSecDisabled ? "#0000215c" : "#000021",
                    cursor: isPrevSecDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button
                  className={`et-sec-next-arrow ${
                    isNextSecDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextSecDisabled ? "#0000215c" : "#000021",
                    cursor: isNextSecDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* take away */}
        <article className="et-take-away">
          <div className="primary__landing__container">
            <h5 className="et-take-title">Take away</h5>
            <p className="et-take-content">
              Launching a trading platform like eToro alternative has never been
              easier. With our eToro Clone, you get a feature-rich, secure, and
              scalable solution that can be tailored to meet your business
              goals. Contact us today to learn more about our eToro copy trading
              clone and take the first step toward building the best eToro
              alternative.
            </p>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="et-take-btn"
            >
              Get Free Consultation{" "}
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
              </span>
            </button>
          </div>
        </article>

        {/* faq */}
        <article className="primary__landing-content-container">
          <div className="landing-faq-wrapper">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="landing-faq-left-title">
                  Frequently Asked <span className="faq-span">Questions.</span>{" "}
                  {""}
                </h6>
              </div>
              <div className="col-lg-6">
                <div>
                  <div className="container">
                    <div className="accordion" id="faq">
                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead1">
                          <a
                            href="#"
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq1"
                            aria-expanded="true"
                            aria-controls="faq1"
                          >
                            What is an eToro Clone?
                          </a>
                        </div>

                        <div
                          id="faq1"
                          className="collapse"
                          aria-labelledby="faqhead1"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            An eToro Clone is a ready-made trading platform that
                            replicates the features of eToro, including copy
                            trading, multi-asset trading, and social trading.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead2">
                          <a
                            href="#"
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq2"
                            aria-expanded="true"
                            aria-controls="faq2"
                          >
                            Is the eToro Clone customizable?
                          </a>
                        </div>

                        <div
                          id="faq2"
                          className="collapse"
                          aria-labelledby="faqhead2"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Yes, our eToro Clone is fully customizable to suit
                            your business requirements.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead3">
                          <a
                            href="#"
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq3"
                            aria-expanded="true"
                            aria-controls="faq3"
                          >
                            What makes your clone the best eToro alternative?
                          </a>
                        </div>

                        <div
                          id="faq3"
                          className="collapse"
                          aria-labelledby="faqhead3"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Our clone offers advanced features, high security,
                            and scalability, making it the best eToro
                            alternative in the market.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead4">
                          <a
                            href="#"
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq4"
                            aria-expanded="true"
                            aria-controls="faq44"
                          >
                            How long does it take to launch an eToro Clone?
                          </a>
                        </div>

                        <div
                          id="faq4"
                          className="collapse"
                          aria-labelledby="faqhead4"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            The deployment time depends on the level of
                            customization. Typically, it can be launched within
                            a few weeks.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead5">
                          <a
                            href="#"
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq5"
                            aria-expanded="true"
                            aria-controls="faq5"
                          >
                            Does your eToro Clone support mobile devices?
                          </a>
                        </div>

                        <div
                          id="faq5"
                          className="collapse"
                          aria-labelledby="faqhead5"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Yes, our eToro app like clone is compatible with
                            Android and iOS devices, ensuring a seamless mobile
                            trading experience.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>

      <ServiceFooter />
    </>
  );
};

export default Etoro;
